import Resource from '@/services/resources/common';

export default class ZoneTypeResource extends Resource {
  constructor(entrypoint = '/zone_types', alias = 'ZoneType') {
    super(entrypoint, alias);
  }
}
